import { WEB_ASSETS } from '@tenfour/contracts'
import s from './visuals.module.css'

export type SignupIdentityKind = 'solo' | 'team' | 'ai' | 'balanced' | 'human'

/** The same clay figures and semantic palette as Queue icons and event discs. */
export function SignupIdentityArt({ kind, className }: { kind: SignupIdentityKind; className?: string }) {
  const assets = WEB_ASSETS.signup.conversation
  const primary = {
    solo: assets.customerBlue,
    team: assets.teams.aqua,
    ai: assets.jobGreen,
    balanced: assets.notificationYellow,
    human: assets.customerBlue,
  }[kind]
  return (
    <span className={`${s.identityArt} ${className ?? ''}`.trim()} data-kind={kind} aria-hidden="true">
      <img src={primary} alt="" width="256" height="256" draggable={false} />
    </span>
  )
}
